import { createSelector } from 'reselect';

export const createUrlSelector =
    (baseUrlSelector: $TSFixMe, languageCodeSelector: $TSFixMe) => (pathSelector: $TSFixMe) =>
        createSelector(
            baseUrlSelector,
            pathSelector,
            languageCodeSelector,
            (baseUrl, path, languageCode) =>
                `${baseUrl as $TSFixMe}${path as $TSFixMe}?language=${languageCode as $TSFixMe}`
        );
